import React, { FC } from "react";

import { TourByIdQuery } from "@graphql/types";
import { Fields, Sidebar } from "./Sidebar";
import Modal from "@components/ui/Modal";

interface ModalProps {
  onClose?: () => void;
  tour: NonNullable<TourByIdQuery["tourById"]>;
  onCheckOut?: (fileds: Fields) => void | undefined;
}

export const SidebarModal: FC<ModalProps> = ({ onClose, onCheckOut, tour }) => {
  return (
    <Modal onClose={onClose} title="">
      <Sidebar onCheckOut={onCheckOut} tour={tour} isModal={true} />
    </Modal>
  );
};
